import Modal, { ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import React, { FC } from 'react';
import { Y200 } from '@atlaskit/theme/colors';
import './refund-and-rebill-confirmation-dialog.scss';

interface ModalProps {
  isOpenModal: boolean;
  isRebillChecked: boolean;
  closeModal: () => void;
}
const ConfirmationDialog: FC<ModalProps> = ({ isOpenModal, isRebillChecked, closeModal }) => {
  return (
    <ModalTransition>
      {isOpenModal && isRebillChecked && (
        <Modal onClose={closeModal}>
          <ModalHeader>
            <div className="refund-rebill-modal">
              <WarningIcon label="" primaryColor={Y200} />
              <ModalTitle>Refund and re-bill will get initiated together</ModalTitle>
            </div>
          </ModalHeader>
          <ModalFooter>
            <Button appearance="subtle" onClick={closeModal}>
              Cancel
            </Button>
            <Button appearance="primary" onClick={closeModal} autoFocus>
              Confirm
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default ConfirmationDialog;
